export let nhomTelegram = 'https://t.me/+IFLkh-2GVvxjNTY1';
export let daiLyChinh = 'https://t.me/maymanladay';
export const setDaiLyChinh = (daiLy: string) => {
    daiLyChinh = daiLy;
}